﻿window.addEventListener("DOMContentLoaded", function () {
    //WEBP-5485
    if (typeof window.__bootstrapLoaded === 'undefined') {
        var script = document.createElement('script');
        script.src = "/static/js/bootstrap-v4.1.3.js";

        document.body.appendChild(script);

    }
})
